/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AppVersion { 
    /**
     * Date Time when application was build successfully
     */
    build_date?: Date;
    /**
     * Version set in applications gradle.properties file
     */
    build_version?: string;
    /**
     * Git branch deployed
     */
    git_branch?: string;
    /**
     * Latest commit id of the branch deployed
     */
    git_commit?: string;
}

